import { FAQ_ITEMS } from "@/data/aeoContent";
import { AeoPageShell, H2, P } from "@/pages/aeo/AeoShell";
import { organizationSchema, breadcrumbSchema, faqSchema } from "@/lib/seo-schemas";

const FAQPage = () => {
  const jsonLd = [
    organizationSchema(),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "FAQ", path: "/faq" },
    ]),
    faqSchema(FAQ_ITEMS.map((f) => ({ question: f.q, answer: f.a }))),
  ];

  return (
    <AeoPageShell
      eyebrow="Frequently asked"
      title="Exhibition Stall Design & Fabrication FAQ"
      summary="Answers to the most common questions our clients ask about exhibition stall design, fabrication, cost, timelines, custom vs modular stands, country pavilions, and turnkey delivery across the UK, USA, Europe, Russia and Asia."
      path="/faq"
      jsonLd={jsonLd}
      excludeSlug="faq"
      excludeType="faq"
    >
      {FAQ_ITEMS.map((f) => (
        <div key={f.q} className="mb-10">
          <H2>{f.q}</H2>
          <P>{f.a}</P>
        </div>
      ))}
    </AeoPageShell>
  );
};

export default FAQPage;
